// src/components/Header.js
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';
import logo from '../assets/logo.png';
import { FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleClickOutside = (e) => {
    if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
      setIsSidebarOpen(false);
    }
  };

  useEffect(() => {
    if (isSidebarOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSidebarOpen]);

  return (
    <header className="header">
      <div className="logo-container">
        <Link to="/">
          <img src={logo} alt="Logo" className="logo" />
        </Link>
      </div>

      {/* Desktop Navigation */}
      <nav className="nav-links">
        <Link to="/">Home</Link>
        <Link to="/aboutus">About Us</Link>
        <Link to="/contactus">Contact Us</Link>
        <Link to="/faq">FAQ</Link>
        <Link to="/blog">Blog</Link>
      </nav>

      <div className="download-btn-container">
        <a href="https://play.google.com/store/apps/details?id=com.shade.app" className="download-btn">Download App</a>
      </div>

      {/* Hamburger for mobile */}
      <div className="mobile-menu-icon" onClick={toggleSidebar}>
        {isSidebarOpen ? <FaTimes size={28} /> : <FaBars size={28} />}
      </div>

      {/* Sidebar for mobile */}
      <div className={`mobile-sidebar ${isSidebarOpen ? 'open' : ''}`} ref={sidebarRef}>
        <Link to="/" onClick={toggleSidebar}>Home</Link>
        <Link to="/aboutus" onClick={toggleSidebar}>About Us</Link>
        <Link to="/contactus" onClick={toggleSidebar}>Contact Us</Link>
        <Link to="/faq" onClick={toggleSidebar}>FAQ</Link>
        <Link to="/blog" onClick={toggleSidebar}>Blog</Link>
        <a href="https://firebasestorage.googleapis.com/v0/b/shade-fc1ff.firebasestorage.app/o/app%2Fapp-release.apk?alt=media&token=054e8400-3aff-4a4a-90f0-09247ec12df5" className="download-btn mobile-download" onClick={toggleSidebar}>
          Download App
        </a>
      </div>
    </header>
  );
};

export default Header;
